<template>
  <div class="w-4/5 pl-8">
    <slot name="default" />
  </div>
</template>
